module.exports = __webpack_public_path__ + "static/img/weixin.a08677a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/weixin.png
// module id = a830
// module chunks = 1